import React from 'react';

const Hieloco = ({ hieloco, menu, readonly }) => {
  return (
    <div
      className={`bg-white ${
        !readonly && 'shadow-md hover:shadow-lg cursor-pointer'
      } flex justify-between w-full p-3`}
      style={{ minHeight: 80 }}
    >
      <div className="flex items-center gap-2 w-11/12">
        <img alt="hielocoImage" src={hieloco.image_url} className="max-h-16" />
        <div>{hieloco?.name}</div>
      </div>
      {menu}
    </div>
  );
};

export default Hieloco;
